<template>
     <div class="modal hide fade" id="modalLedgerBank" tabindex="-1" role="dialog" aria-labelledby="modalLedgerBank" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Rekening Bank</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group row">
                                <label for="date" class="col-sm-3 col-form-label text-left">Date</label>
                                <div class="col-sm-9">
                                    <datetime v-model="ledger.date" format="dd/MM/yyyy" class="form-control" value-zone="Asia/Jakarta" zone="Asia/Jakarta" :disabled="ledger.id !== null"></datetime>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="company_no" class="col-sm-3 col-form-label text-left">Company</label>
                                <div class="col-sm-9">
                                    <select v-model="ledger.company_no" class="form-control" :disabled="ledger.lock">
                                        <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="bank_id" class="col-sm-3 col-form-label text-left">Bank</label>
                                <div class="col-sm-9">
                                    <select v-model="ledger.bank_id" class="form-control" :disabled="ledger.lock">
                                        <option v-for="b in bankList" :key="b.id" :value="b.id">{{ b.name }} - {{ b.account_no }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="bank_id" class="col-sm-3 col-form-label text-left">Debit</label>
                                <div class="col-sm-9">
                                    <input type="text" v-model="ledger.debit" class="form-control form-control-right" v-money="money" :disabled="ledger.lock"/>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="bank_id" class="col-sm-3 col-form-label text-left">Credit</label>
                                <div class="col-sm-9">
                                    <input type="text" v-model="ledger.credit" class="form-control form-control-right" v-money="money" :disabled="ledger.lock"/>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="bank_id" class="col-sm-3 col-form-label text-left">Notes</label>
                                <div class="col-sm-9">
                                    <textarea rows="5" class="form-control" v-model="ledger.notes"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal" @click="create()">Save</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal" >Cancel</button>
                </div>
            </div>
        </div>
     </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LedgerBankModal',
  props: ['ledger'],
  data () {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
      companyList: state => state.companies.companyList,
      bankList: state => state.banks.bankList,
      authUser: state => state.users.authUser
    })
  },
  methods: {
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.ledger.date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = (Math.round(remaining / (1000 * 3600 * 24)))
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.cash.cash_date = new Date().toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.cash.cash_date = new Date().toISOString()
      }
    },
    create () {
      this.$emit('save', this.ledger)
    }
  }
}
</script>
